var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.829,
    height: 8.826,
    viewBox: "0 0 14.829 8.826",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_24",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 24",
    d: "M-2892.277,1466.668l6.036-6,5.964,5.957",
    transform: "translate(2893.691 -1459.257)",
    fill: "none",
    stroke: "#2b2b2b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryArrow);
export default __webpack_public_path__ + "static/media/history-arrow.084cf08d4872b892caa73d23301e08c0.svg";
export { ForwardRef as ReactComponent };